var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"card-wrap",attrs:{"shadow":"hover"}},[_c('div',{staticClass:"flex-c"},[_c('img',{attrs:{"src":require("../../../../assets/image/noList.png"),"alt":""}}),_c('p',[_vm._v("暂无该活动内容")])])])}
var staticRenderFns = []

export { render, staticRenderFns }